// FE-owned grouping: each `${resource}/${action}` pair maps to a shared label
// key. Pairs sharing a key are aggregated into one card / leaderboard column
// (their counts are summed). The label key doubles as the group id. Pairs not
// listed here fall back to their own raw group, labeled by the raw action.
export const PAY_PER_USE_OPERATION_LABEL: Record<string, string> = {
  // VIN decoding
  'VIN_DECODER/DECODE': 'page.payPerUseMetrics.operation.vinDecoding',
  'VIN_DECODER/DECODE_FEATURE_BY_VIN': 'page.payPerUseMetrics.operation.vinDecoding',
  // Price report
  'SOURCING/CREATE_PRICE_REPORT': 'page.payPerUseMetrics.operation.priceReport',
  'VEHICLE/CREATE_VEHICLE_PRICE_REPORT': 'page.payPerUseMetrics.operation.priceReport',
  'INTEREST/CREATE_PRICE_REPORT': 'page.payPerUseMetrics.operation.priceReport',
  'USER/CREATE_FAST_PRICING_PRICE_REPORT_REQUEST': 'page.payPerUseMetrics.operation.priceReport',
  // Invoice extraction
  'AI_TOOL/INVOICE_EXTRACTION_FROM_FILE': 'page.payPerUseMetrics.operation.invoiceExtraction',
  'AI_TOOL/INVOICE_EXTRACTION_FROM_ZIP': 'page.payPerUseMetrics.operation.invoiceExtraction',
  // Background removal
  'VEHICLE_PHOTO/CREATE_VEHICLE_PHOTO_WITH_REMOVED_BACKGROUND':
    'page.payPerUseMetrics.operation.backgroundRemoval',
  'SALE_VEHICLE_PHOTO/CREATE_SALE_VEHICLE_PHOTO_WITH_REMOVED_BACKGROUND':
    'page.payPerUseMetrics.operation.backgroundRemoval',
  // Standalone
  'AI_TOOL/VEHICLE_DATA_SCAN': 'page.payPerUseMetrics.operation.vehicleDataScan',
  'CEBIA/AUTO_TRACER': 'page.payPerUseMetrics.operation.cebiaAutotracer',
  'VIN_DECODER/DECODE_MANUFACTURE_TIME': 'page.payPerUseMetrics.operation.cebiaRokvy',
  'VEHICLE/SALES_GENERATE_DESCRIPTION': 'page.payPerUseMetrics.operation.aiDescription',
  'PHOTO_CHECKER_REPORT/CREATE_PHOTO_CHECKER_REPORT':
    'page.payPerUseMetrics.operation.photoCheckerReport',
  'CUSTOMER_CONTRACT_INFORMATION/VERIFY_CUSTOMER_DISTRAINT':
    'page.payPerUseMetrics.operation.customerDistraint',
};
